export default {
  contemEspeciais: (value) => {
    return /[#?!@$%^&*-]/.test(value)
  },
  contemMinusculas: (value) => {
    return /[A-Z]/.test(value)
  },
  contemMaiuscula: (value) => {
    return /[a-z]/.test(value)
  },
  contemNumero: (value) => {
    return /[0-9]/.test(value)
  },
}